module.exports = __webpack_public_path__ + "jinduchau.png?613a71832c3cbf2ab0285b0155756151";


//////////////////
// WEBPACK FOOTER
// ./static/assets/jinduchau.png
// module id = 533
// module chunks = 0